<template>
  <div id="top-bar">
    <div class="content">
      <div class="logo-box">
        <!-- <span>共青团委</span> -->
        <a href="https://www.mini1.cn/">
          <img class="img-logo-mini" src="../assets/images/logo_mini.png" />
        </a>
        <a href="http://www.ncda.org.cn/">
          <img class="img-logo-gong" src="../assets/images/logo_gong.png" />
        </a>
      </div>
      <img
        class="img-btn-menu"
        src="../assets/images/btn_menu.png"
        @click="toMenuFn"
      />
    </div>
    <div class="swipe-wrap">
      <van-swipe :autoplay="2000" :loop="true">
        <van-swipe-item v-for="(item, index) in imageArr" :key="index">
          <a :href="item.link">
            <img v-lazy="item.img" />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      imageArr: [
        {
          img: require('../assets/images/slideshow1.jpeg'),
          link: 'javascript:void(0)'
        },
        {
          img: require('../assets/images/slideshow2.jpg'),
          link: 'http://www.ncda.org.cn/'
        },
        {
          img: require('../assets/images/slideshow3.jpg'),
          link: 'javascript:void(0)'
        },
        // {
        //   img: require('../assets/images/bg_china_map.jpg'),
        //   link: 'javascript:void(0)'
        // },
        {
          img: require('../assets/images/slideshow5.jpg'),
          link: 'https://activities.mini1.cn/fe/starPlan/#/'
        }
      ]
    };
  },
  methods: {
    toMenuFn() {
      this.$router.push('/Menu');
    }
  }
};
</script>

<style lang="scss" scoped>
#top-bar {
  width: 750px;
  position: relative;
  .content {
    width: 750px;
    height: 80px;
    background: #000;
    position: fixed;
    z-index: 999;
    top: 0;

    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0 20px;
    .logo-box {
      display: flex;
      align-items: center;
      .img-logo-gong {
        // width: 65px;
        // height: 59px;
        width: 148px;
        height: 42px;
        margin-left: 40px;
      }
      span {
        font-size: 28px;
        font-weight: 800;
        margin: 0 20px;
      }
      .img-logo-mini {
        width: 104px;
        height: 37px;
      }
    }
    .img-btn-menu {
      width: 52px;
      height: 33px;
    }
  }
  /deep/ .swipe-wrap {
    margin-top: 80px;
    width: 750px;
    .van-swipe {
      width: 750px;
    }
    img {
      width: 750px;
      height: 1334px;
    }
    .van-swipe__indicators {
      i {
        width: 20px;
        height: 20px;
        opacity: 1;
        margin-right: 10px;
      }

      .van-swipe__indicator.van-swipe__indicator--active {
        background-color: #ff7462;
      }
    }
  }
}
</style>
